module.exports = __webpack_public_path__ + "static/img/slide-3-bike.22d23b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-3-bike.png
// module id = WD6O
// module chunks = 1